import Cookies from "universal-cookie";
import dayjs from 'dayjs';
import { CookieKey } from '../enums/CookieKey';

const urlMode = process.env.REACT_APP_URL_MODE;
const urlDomain = process.env.REACT_APP_URL_DOMAIN;

export const CookiesHelper = {

    /**
     *
     * @param {*} expiryDays
     * @param {*} expiryDateTime will override expiryDays if present
     * @returns
     */
    getCookiesOptions: (expiryDays = 1, expiryDateTime = null) => {
        const options = {};
        const urlMode = process.env.REACT_APP_URL_MODE;
        const urlDomain = process.env.REACT_APP_URL_DOMAIN;

        let expiryMoment;

        if (!expiryDateTime)
            expiryMoment = dayjs().add(expiryDays, 'day');

        // Options
        options.expires = expiryDateTime || expiryMoment.toDate();
        options.path = '/';
        if (urlMode === 'subdomain')
            options.domain = `.${urlDomain}`;

        return options;
    },

    /**
     *
     * @param {*} expiryDays
     * @param {Date} expiryDateTime will override expiryDays if present
     * @returns
     */
    setCookies: (
        cookieName, cookieValue,
        expiryDays = 1,
        expiryDateTime = null,
    ) => {
        const cookies = new Cookies();

        const options = CookiesHelper.getCookiesOptions(expiryDays, expiryDateTime);

        // Set cookies
        cookies.set(cookieName, cookieValue, options);
    },

    getCookie: cookieName => {
        const cookies = new Cookies();

        let actualCookieName = cookieName;

        if (cookieName === CookieKey.access_token) {
            const cookiePrefix = process.env.REACT_APP_COOKIE_PREFIX;
            actualCookieName = `${cookiePrefix}at`;
        }

        return cookies.get(actualCookieName);
    },

    removeCookie: cookieName => {
        const cookies = new Cookies();

        let actualCookieName = cookieName;

        if (cookieName === CookieKey.access_token) {
            const cookiePrefix = process.env.REACT_APP_COOKIE_PREFIX;
            actualCookieName = `${cookiePrefix}at`;
        }

        const options = {};
        options.path = '/';
        options.expires = new Date(Date.now() + (3600 * 24 * 14 * 1000)); // 14 days
        if (urlMode === 'subdomain')
            options.domain = `.${urlDomain}`;

        console.log('removeCookie', {
            actualCookieName,
            options,
            cookie: cookies.get(actualCookieName),
        });
        cookies.remove(actualCookieName, options);
    },
};
